import React from 'react'

import { makeStyles } from '../../themes/ThemeProvider'
import Box from '../base/Box'
import Typography from '../base/Typography'
import Button from './Button'

const useStyles = makeStyles({
  button: {
    fontSize: '11px',
    fontWeight: 'initial',
    minWidth: '5px',
    padding: '0 3px'
  }
})

export type PackageJobVisitProps = {
  packageJobVisit: PackageJobVisitLinkProps
}

export interface PackageJobVisitLinkProps {
  packageId?: string
  jobId?: string
  visitId?: string
  onClickPackage?(event: React.SyntheticEvent, packageId: string): void
  onClickJob?(event: React.SyntheticEvent, jobId: string): void
  onClickVisit?(event: React.SyntheticEvent, visitId: string): void
}

const PackageJobVisitLink: React.FC<PackageJobVisitLinkProps> = (props) => {
  const classes = useStyles()
  const {
    jobId,
    packageId,
    visitId,
    onClickPackage,
    onClickJob,
    onClickVisit
  } = props

  function buttonsList(): React.ReactNodeArray {
    const list = []
    const button = (
      <Button className={classes.button} customSize="xs" onClick={() => {}}>
        button
      </Button>
    )
    if (packageId && onClickPackage) {
      list.push(
        React.cloneElement(
          button,
          {
            onClick: (e: React.SyntheticEvent) => onClickPackage(e, packageId)
          },
          `P${packageId}`
        )
      )
    }

    if (jobId && onClickJob) {
      list.push(
        React.cloneElement(
          button,
          { onClick: (e: React.SyntheticEvent) => onClickJob(e, jobId) },
          `J${jobId}`
        )
      )
    }

    if (visitId && onClickVisit) {
      list.push(
        React.cloneElement(
          button,
          { onClick: (e: React.SyntheticEvent) => onClickVisit(e, visitId) },
          `V${visitId}`
        )
      )
    }

    return list
  }

  const buttons = buttonsList()

  return (
    <Box display="flex" alignItems="center">
      {buttons.map((button, index) => (
        <>
          {!!index && <Typography>-</Typography>}
          {button}
        </>
      ))}
    </Box>
  )
}

export default PackageJobVisitLink
